import { AttachmentProvider as types } from "@/core/providers/attachmentProvider";

export class AttachmentProvider implements types {
  // 由于可以同时上传多个附件，以 id 为 key 存储不同附件的状态
  store = {};

  copyCallback = (res: boolean) => {};

  copy = (url: string) => {
    const inp = document.createElement("input");
    inp.setAttribute("value", url);
    inp.setAttribute("style", "opacity: 0");
    document.body.append(inp);
    inp.select();
    try {
      if (document.execCommand("Copy")) {
        this.copyCallback(true);
      } else {
        this.copyCallback(false);
      }
    } catch (err) {
      this.copyCallback(false);
    }
    inp.remove();
  };

  download = (url, name) => {
    window.open(url, "_blank");
  };

  upload = async (file: File, onProgress) => {
    return new Promise((resolve, reject) => {
      reject(new Error("附件上传方法未定义"));
    });
  };

  beforeUpload(file: File, id) {
    return true;
  }

  onSelectFiles(files: FileList) {
    return true;
  }
}
